import React from "react";
import { useSelector } from "react-redux";
import VisibilitySensor from "react-visibility-sensor";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";
import useWindowSize from "./hooks/useWindowSize";

function TableDescriptor({
  title,
  text,
  image,
  componentsList = [],
  applyBuildingClassName,
  applyHeightInsteadOfTextAndComponentList,
  secondaryImage,
}) {
  const windowWidth = useWindowSize();
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <article
          className="table-descriptor"
          style={getVisibleSensorAnimation(isVisible, "width-increase 1s")}
        >
          <header
            className={`table-descriptor__header${setAdditionalClasses(
              ["general-2lp-just-wide-screen"],
              [applyHeightInsteadOfTextAndComponentList]
            )}`}
            style={getVisibleSensorAnimation(
              isVisible,
              "fadeIn 1s 0.5s backwards"
            )}
          >
            <h2 className="table-descriptor__heading">{title}</h2>
          </header>
          {secondaryImage && (
            <VisibilitySensor partialVisibility>
              {({ isVisible }) => (
                <img
                  src={secondaryImage}
                  className="table-descriptor__secondary-image"
                  style={getVisibleSensorAnimation(
                    isVisible,
                    "fadeInBright 1s 1s backwards"
                  )}
                />
              )}
            </VisibilitySensor>
          )}
          <div
            className={`table-descriptor__body${setAdditionalClasses(
              ["building"],
              [applyBuildingClassName]
            )}`}
          >
            <div
              className={`table-descriptor__body-first-part${setAdditionalClasses(
                ["building"],
                [applyBuildingClassName]
              )}`}
              style={getVisibleSensorAnimation(
                isVisible,
                "fadeIn 1s 0.75s backwards"
              )}
            >
              <p
                className={`table-descriptor__text${setAdditionalClasses(
                  [applyHeightInsteadOfTextAndComponentList],
                  [applyHeightInsteadOfTextAndComponentList]
                )}`}
              >
                {text}
              </p>
              <div className="table-descriptor__components">
                {componentsList.map((comp, index) => (
                  <div
                    key={index}
                    className="table-descriptor__component"
                    style={
                      windowWidth > 768
                        ? getVisibleSensorAnimation(
                            isVisible,
                            `scale-y 1s ${0.75 + index * 0.45}s backwards`
                          )
                        : {}
                    }
                  >
                    {comp}
                  </div>
                ))}
              </div>
            </div>
            <div
              className={`table-descriptor__body-second-part${setAdditionalClasses(
                ["building"],
                [applyBuildingClassName]
              )}`}
            >
              <div
                className="absolute-wrapper"
                style={getVisibleSensorAnimation(
                  isVisible,
                  `${
                    generalSettings.rtlLanguage
                      ? applyBuildingClassName
                        ? "from-right-to-left"
                        : "from-right-to-left-flipped"
                      : "from-right-to-left"
                  } 1s 0.5s backwards`
                )}
              >
                <img
                  src={image}
                  alt=""
                  className={`table-descriptor__image${setAdditionalClasses(
                    ["building", "scale-image"],
                    [
                      applyBuildingClassName,
                      applyHeightInsteadOfTextAndComponentList,
                    ]
                  )}`}
                />
              </div>
            </div>
          </div>
        </article>
      )}
    </VisibilitySensor>
  );
}

export default TableDescriptor;
